/**
 * ArrangeOnboarding — content for the Arrange mode onboarding panel.
 *
 * Pure presentational component: renders the title, body and CTA.
 * Visibility and sessionStorage persistence are handled by OnboardingContext /
 * OnboardingOverlay — this component only renders the content slot.
 */
import { useState } from 'react'

import { useI18n } from '../../../../shared/i18n/useI18n.js'

import { ArrangeMode }  from '../../../../shared/ui/icons/index.js'

import styles from './ArrangeOnboarding.module.scss'
import pane_styles from './OnboardingOverlay.module.scss' // for shared styles like .title

export function ArrangeOnboarding({isMobile, loadExpanded = false}) {
  const { t } = useI18n()
  const [expanded, setExpanded] = useState(loadExpanded)

  return (
    <div className={pane_styles.content}>
      <span className={pane_styles.title}><ArrangeMode />{t('product.arrange_onboarding_title')}</span>
      {expanded && <p className={pane_styles.body}>{t('product.arrange_onboarding_par1')}</p>}
      <p className={pane_styles.cta}>{t('product.arrange_onboarding_cta')}</p>
      <span
        className={pane_styles.cta}
        onClick={() => setExpanded((e) => !e)}
        style={{ cursor: 'pointer' }}
      >
        {expanded ? t('product.onboarding_hide_details') : t('product.onboarding_learn_more')}
      </span>
    </div>
  )
}
